import React from 'react';
import { REBRAND_ANNOUNCEMENT } from '../config/site';

const AnnouncementBar = () => {
  return (
    <div className="announcement-bar" role="status">
      <div className="announcement-bar-text">
        <p>{REBRAND_ANNOUNCEMENT}</p>
      </div>
    </div>
  );
};

export default AnnouncementBar;
